<template>
  <div class="container-header">
    <!-- header导航 -->
    <div class="header">
      <div class="left">
        <div class="logo" @click="goIndex">
          <img v-lazy="require('@/assets/fp1.png')" alt="丰派收银" />
        </div>
        <div class="nav">
          <div
            :class="
              routerName == '/webindex'
                ? 'nav-item nav-item-active'
                : 'nav-item'
            "
            @click.stop="routerMenu('/webindex')"
          >
            首页
          </div>
          <div
            :class="
              homeRouter.includes(routerName)
                ? 'nav-item nav-item-product nav-item-active'
                : 'nav-item nav-item-product'
            "
            @mouseenter="productMenuList = true"
            @mouseleave="productMenuList = false"
          >
            产品
            <div v-show="productMenuList" class="productContainer-arrow"></div>
            <div v-show="productMenuList" class="productContainer">
              <!-- <div
                @click.stop="routerMenu('/web/webproduct')"
                :class="
                  routerName == '/web/webproduct'
                    ? 'productContainer-item active'
                    : 'productContainer-item'
                "
              >
                收银系统
              </div>
              <div @click.stop="goGb" class="productContainer-item">
                智慧零售
              </div>
              <div @click.stop="goDb" class="productContainer-item">
                订货平台
              </div> -->
              <div
                :class="[
                  'productContainer-item',
                  routerName == item.router ? 'active' : '',
                ]"
                v-for="item in menuList"
                :key="item.id"
                @click.stop="gotoMenu(item)"
              >
                <img :src="item.img" alt="" class="item-left" />
                <div class="item-right">
                  <div class="ir-tit">{{ item.tit }}</div>
                  <div class="ir-tip">{{ item.tip }}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="
              routerName == '/web/webdownload'
                ? 'nav-item nav-item-active'
                : 'nav-item'
            "
            @click.stop="routerMenu('/web/webdownload')"
          >
            下载
          </div>
          <div
            :class="
              routerName == '/web/webintroduce'
                ? 'nav-item nav-item-active'
                : 'nav-item'
            "
            @click.stop="routerMenu('/web/webintroduce')"
          >
            公司简介
          </div>
          <!-- 暂时隐藏结构已写好 -->
          <div
            :class="
              routerName == '/web/webhelp'
                ? 'nav-item nav-item-active'
                : 'nav-item'
            "
            @click.stop="routerMenu('/web/webhelp')"
          >
            客户支持
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right-item right-item2" @click.stop="gotoLogin">
          商户登录
        </div>
        <div class="right-item right-item1" @click="gotoRegister">免费试用</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "iheader",
  data() {
    return {
      routerName: "",
      productMenuList: false, //产品下拉
      homeRouter: [
        "/web/webproduct",
        "/web/webproductauto",
        "/web/webproductwx",
      ],
      menuList: [
        {
          id: 1,
          tit: "丰派云POS",
          tip: "专注零售领域的新零售SaaS系统",
          router: "/web/webproduct",
          img: require("@/assets/newdownload/headericon1.png"),
        },
        {
          id: 2,
          tit: "智慧零售",
          tip: "全场景私域经营解决方案",
          router: "",
          img: require("@/assets/newdownload/headericon2.png"),
        },
        {
          id: 3,
          tit: "订货商城",
          tip: "一站式企业采购平台",
          router: "",
          img: require("@/assets/newdownload/headericon3.png"),
        },
        {
          id: 4,
          tit: "自助收银",
          tip: "降低收银成本，提高收银效率",
          router: "/web/webproductauto",
          img: require("@/assets/newdownload/headericon4.png"),
        },
        {
          id: 5,
          tit: "微商城",
          tip: "多渠道数智化经营",
          router: "/web/webproductwx",
          img: require("@/assets/newdownload/headericon5.png"),
        },
      ],
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.routerName = val.path;
      },
    },
  },
  mounted() {
    this.routerName = this.$route.path;
  },
  methods: {
    gotoMenu(result) {
      if (result.id == 1) {
        this.routerMenu("/web/webproduct");
      } else if (result.id == 2) {
        this.goGb();
      } else if (result.id == 3) {
        this.goDb();
      } else if (result.id == 4) {
        this.routerMenu("/web/webproductauto");
      } else if (result.id == 5) {
        this.routerMenu("/web/webproductwx");
      }
    },
    gotoLogin() {
      location.href = "https://www.fp1123.com/fpPos/#/login";
    },
    gotoRegister() {
      location.href = "https://www.fp1123.com/fpPos/#/login";
    },
    goGb() {
      window.open("https://gb.fp1123.com");
    },
    goDb() {
      window.open("https://db.fp1123.com");
    },
    goIndex() {
      this.$router.push({ name: "webindex" });
    },

    routerMenu(result) {
      console.log(result);
      if (!result) {
        this.$message.warning("暂无网址");
        return;
      }
      this.$router.push({ path: result });
      //   this.routerName = result;
    },
  },
};
</script>
<style lang="less" scoped>
.container-header {
  width: 100%;
  min-width: 950px;
  display: flex;
  justify-content: center;
  box-shadow: 4px 4px 12px rgba(55, 99, 170, 0.08);
  backdrop-filter: blur(8px);
  position: fixed;
  background: rgba(255, 255, 255, 0.9);
  z-index: 8;
  left: 0;
  top: 0;
}
.header {
  width: 1200px;
  min-width: 950px;
  padding: 0 10px 0 40px;
  height: 64px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    height: 64px;
    // line-height:80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .logo {
      // width: 152px;
      height: 40px;
      overflow: hidden;
      display: flex;
      align-items: center;
      margin-right: 40px;
      img {
        // width: 152px;
        height: 40px;
      }
    }
    .nav {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 100px;
      .nav-item {
        cursor: pointer;
        box-sizing: border-box;
        height: 64px;
        line-height: 64px;
        color: #333333;
        font-size: 16px;
        // margin-right: 50px;
        padding-right: 50px;
        &:hover {
          color: #3d60dd;
        }
      }
      .nav-item-product {
        position: relative;
      }
      .productContainer-arrow {
        position: absolute;
        top: 54px;
        left: 30px;
        width: 0;
        height: 0;
        filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.5));
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        z-index: 200;
      }
      .productContainer {
        position: absolute;
        top: 60px;
        left: -20px;
        width: 350px;
        height: 396px;
        z-index: 100;
        filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.1));
        background: #ffffff;
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .productContainer-item {
          width: 350px;
          height: 76px;
          padding: 10px 20px;
          display: flex;
          align-items: center;
          background: #ffffff;
          &:hover {
            background: #f2f4f5;
            .item-right {
              .ir-tit {
                color: #336fff;
              }
              // .ir-tip {
              //   color: #336FFF;
              // }
            }
          }
          &.active {
            background: #f2f4f5;
            .item-right {
              .ir-tit {
                color: #336fff;
              }
              // .ir-tip {
              //   color: #336FFF;
              // }
            }
          }
          .item-left {
            width: 56px;
            height: 56px;
            margin-right: 16px;
          }
          .item-right {
            .ir-tit {
              font-weight: 400;
              font-size: 16px;
              line-height: 24px;
              color: #292929;
            }
            .ir-tip {
              margin-top: 4px;
              font-weight: 400;
              font-size: 13px;
              line-height: 20px;
              color: #51565d;
            }
          }
        }
        // .productContainer-item:hover {
        //   background: #c9d9f1;
        // }
        // .active {
        //   color: #3d60dd;
        //   background: #f5f7fa;
        // }
      }
      .nav-item:last-child {
        margin-right: 0;
      }
      .nav-item-active {
        font-weight: bold;
        color: #3d60dd;
        font-size: 16px;
      }
    }
  }
  .right {
    width: 238px;
    height: 64px;
    flex: 1;
    display: flex;
    justify-content: flex-end;
    .right-item {
      cursor: pointer;
      box-sizing: border-box;
      height: 64px;
      line-height: 64px;
      color: #333333;
      font-size: 16px;
      margin-right: 36px;
    }
    .right-item2 {
      &:hover {
        color: #3d60dd;
      }
    }
    .right-item1 {
      width: 112px;
      height: 64px;
      text-align: center;
      background: #336fff;
      color: #ffffff;
    }
    .dls {
      cursor: pointer;
      width: 112px;
      height: 64px;
      background: #336fff;
      color: #fff;
      text-align: center;
      line-height: 64px;
    }
    .right-item:last-child {
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/header.vue